var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mb-2",on:{"click":function($event){return _vm.$refs.questionsGrid.addItem()}}},[_vm._v("Додати запитання")]),_c('e-aristo-question-index',{ref:"questionsGrid"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }